import { render, staticRenderFns } from "./BbsViews.vue?vue&type=template&id=09a70de6&"
import script from "./BbsViews.vue?vue&type=script&lang=js&"
export * from "./BbsViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/BbsViews.vue"
export default component.exports